import appParameters from '../../../components/utils/AppParameters';
import modeType from '../../../constants/ModeConstants';
import sessionActions from '../../../actions/SessionActions';
import storeManager from '../../../store/StoreManager';
import masterUniverseUtils from '../../../components/utils/MasterUniverseUtils';
import audioClipartModel from '../../utils/AudioClipartModel';
import exportPlayerController from '../../utils/ExportPlayerController';

const zipLoader = {
    loadData (type) {
        const store = storeManager.getStore();

        if (appParameters.isPrintMode() || appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
            store.dispatch(sessionActions.setCaptionsLoaded());

            if (appParameters.context == modeType.EXPORT_PLAYER)
                exportPlayerController.loadData();

            return;
        }

        if (appParameters.getMode() == modeType.DOWNLOAD)
            return;

        if (appParameters.getMode() == modeType.PLAYER)
            return;

        if (type == 'cartoonist')
            return this.loadClipartJSON();
        else
            return this.loadAudioClipartJSON();
    },
    loadAudioClipartJSON() {
        audioClipartModel.addToStateAudioClipart();
    },
    loadClipartJSON () {
        masterUniverseUtils.loadTheme();
    }
};

export default zipLoader;



/** WEBPACK FOOTER **
 ** ./src/components/accordion/clipartUtils/ZipLoader.js
 **/